import { onMessageFromWebApp } from "./webAppMessenger";
import { QR_START_SCANNING, QR_STOP_SCANNING } from "./messageTypes";

const insomnia = window.plugins && window.plugins.insomnia;

if (insomnia) {
  onMessageFromWebApp(QR_START_SCANNING, async () => {
    insomnia.keepAwake();
  });

  onMessageFromWebApp(QR_STOP_SCANNING, async () => {
    insomnia.allowSleepAgain();
  });
}
